import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Classifications } from "@/components/site/Classifications";
import { Pricing } from "@/components/site/Pricing";
import { Reviews } from "@/components/site/Reviews";
import { Instructor } from "@/components/site/Instructor";
import { Gallery } from "@/components/site/Gallery";
import { QuoteForm } from "@/components/site/QuoteForm";
import { StickyContact } from "@/components/site/StickyContact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="grain bg-[#060c1f] min-h-screen">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Services />
          <Classifications />
          <Pricing />
          <Reviews />
          <Instructor />
          <Gallery />
          <QuoteForm />
        </main>
        <Footer />
        <StickyContact />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#0f1c40",
              border: "1px solid rgba(140,165,255,0.15)",
              color: "#f8fafc",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
